'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./CookieNotice.scss');

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { className: styles.CookieNotice },
    _react2.default.createElement(
      'span',
      { className: styles.CookieNotice__inner },
      'We use cookies to ensure that we give you the best experience on our website. ',
      _react2.default.createElement(
        _reactRouter.Link,
        { to: 'cookiepolicy' },
        'Click here for more information.'
      ),
      _react2.default.createElement(
        'span',
        { className: styles.CookieNotice__discard, onClick: props.onDiscard },
        'Ok, got it!'
      )
    )
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieNotice/CookieNotice.jsx
// module id = 2725
// module chunks = 0